import { Box, IconButton, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Sl No.",
    id: "siNo",
  },
  {
    label: "Topic",
    id: "topic",
  },
  {
    label: "Document",
    id: "document",
    render: (data) => (
      <Button
        variant="text"
        onClick={() => window.open(data.document, "_blank")}
      >
        View Document
      </Button>
    ),
  },

  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];

export const getKnowledgeSharingFormConfig = () => [
  {
    name: "topic",
    type: "text",
    label: "Topic",
    placeholder: "Enter Topic",
    required: true,
  },
  // {
  //   name: "document",
  //   type: "file",
  //   label: "Document",
  //   placeholder: "Upload Document",
  //   required: true,
  //   accept: ".pdf,.doc,.docx",
  // },
];
